module.exports = __webpack_public_path__ + "68362a2f8b1fbc8068c9de240179f06e.png";